import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLAnchorElement> {
  static values = {
    modalId: String,
    url: String,
  }

  declare modalIdValue: string
  declare urlValue: string
  private originalContent: string = ''
  private isLoading: boolean = false
  private readonly disabledClasses = [
    'tw-opacity-50',
    'tw-pointer-events-none',
  ] as const

  connect(): void {
    window.eventHub.$on('modal-opened', this.handleModalOpened)
  }

  disconnect(): void {
    window.eventHub.$off('modal-opened', this.handleModalOpened)
    this.restoreLinks()
  }

  openModal(event: Event): void {
    event.preventDefault()
    event.stopPropagation()

    if (this.isLoading) {
      return
    }

    if (!window.modalCitizen) {
      return
    }

    this.isLoading = true

    this.originalContent = this.element.innerHTML
    this.element.innerHTML =
      '<span class="sf-spinner sf-spinner-primary tw-inline-block"></span>'
    this.element.classList.add('tw-pointer-events-none')

    this.toggleOtherLinks(false)

    // Open the XHR modal
    try {
      window.modalCitizen.openXhrModal(
        event,
        this.modalIdValue,
        this.urlValue,
        {}
      )
    } catch {
      this.restoreLinks()
    }
  }

  private toggleOtherLinks(enabled: boolean): void {
    const allLinks = document.querySelectorAll(
      '[data-controller~="module-contents"]'
    )
    allLinks.forEach((link) => {
      if (link instanceof HTMLElement) {
        // When disabling, exclude current element; when enabling, include all
        if (!enabled && link === this.element) {
          return
        }

        if (enabled) {
          link.classList.remove(...this.disabledClasses)
        } else {
          link.classList.add(...this.disabledClasses)
        }
      }
    })
  }

  private handleModalOpened = (): void => {
    // Event is emitted via Vue eventHub when any modal opens
    // We restore our links since the modal has loaded
    this.restoreLinks()
  }

  private restoreLinks(): void {
    if (!this.isLoading) return

    if (this.originalContent) {
      this.element.innerHTML = this.originalContent
    }
    this.element.classList.remove('tw-pointer-events-none')

    this.toggleOtherLinks(true)

    this.isLoading = false
    this.originalContent = ''
  }
}
